import React from 'react';
import { classNames } from '../../utils/class-names.js';

const Display = /*#__PURE__*/ React.forwardRef(({ as: Tag = "div", size, bold, className, ...props }, ref)=>{
    const classes = classNames(`display-${size}`, bold && "display-bold", className);
    return /*#__PURE__*/ React.createElement(Tag, {
        ref: ref,
        className: classes,
        ...props
    });
});

export { Display };
//# sourceMappingURL=Display.js.map
